import { render, staticRenderFns } from "./HsaBankFeeScheduleAndInterestRatesInfo.vue?vue&type=template&id=0faba536&scoped=true"
import script from "./HsaBankFeeScheduleAndInterestRatesInfo.vue?vue&type=script&lang=ts"
export * from "./HsaBankFeeScheduleAndInterestRatesInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faba536",
  null
  
)

export default component.exports